import { DCBaseWheelDownEvent, DCBaseWheelUpEvent, DCGamepadDownEvent, DCGamepadUpEvent, DCKeyDownEvent, DCKeyUpEvent, DCMouseDownEvent, DCMouseUpEvent, DCGamepadAxesMoveEvent, } from "./Register/index.js";
export const DivineControlEventManager = {
    _events: new Map(),
    registerEvents(event) {
        event.forEach((event) => this._events.set(event.eventType, event));
    },
    getEvent(id) {
        return this._events.get(id);
    },
};
DivineControlEventManager.registerEvents([
    //mouse
    new DCMouseDownEvent(),
    new DCMouseUpEvent(),
    //gamepad button
    new DCGamepadDownEvent(),
    new DCGamepadUpEvent(),
    //game axes
    new DCGamepadAxesMoveEvent(),
    //keyabord
    new DCKeyDownEvent(),
    new DCKeyUpEvent(),
    //wheel
    new DCBaseWheelDownEvent(),
    new DCBaseWheelUpEvent(),
]);
